import { gql } from '@apollo/client';

export const GET_DISAGGREGATION_VALUES_BY_ID = gql`
  query GetDisaggregationValuesById($id: ID!) {
    values: getDisaggregationValuesById(id: $id) {
      id
      name
    }
  }
`;

export const GET_DISAGGREGATION_VALUES_BY_NAME = gql`
  query GetDisaggregationValuesByName($name: String!) {
    values: getDisaggregationValuesByName(name: $name) {
      id
      name
    }
  }
`;
